import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import {
	Row,
	Col,
	Input,
	Button,
	notification,
	Result,
	Divider,
	Spin,
	Space,
	Avatar,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
	XCardsTransparent,
	XThemeForm,
	XModal,
	XSelect,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeFilterCards,
	XUploadCustom,
	XThemeUploadProfile,
	XThemeInputText,
	XThemeSelect,
	XThemeButton,
	XThemeGradientButton,
	XThemeUploadProfile2,
} from '../../styles/GlobalThemeStyle';
import {
	ArrowLeftOutlined,
	UploadOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { XContainer } from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import axios from 'axios';

import {
	filterByLabel,
	handleInputChange,
	handleSelectChange,
	lowerCaseInput,
	upperCaseInput,
	validateMobileNumber,
} from '../../utils/formFunctions';
import config from '../../config';

// actions

import {
	getHospitalByIdApi,
	getHospitalByIdReset,
} from '../../actions/getHospitalByIdAction';
import {
	editHospitalApi,
	editHospitalReset,
} from '../../actions/editHospitalAction';
import {
	addHospitalApi,
	addHospitalReset,
} from '../../actions/addHospitalAction';
import {
	checkModulePermissions,
	getFileNameFromDocPath,
	getUserToken,
} from '../../utils/helper';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import {
	getOrganizationsApi,
	getOrganizationsReset,
} from '../../actions/getOrganizationsAction';
import {
	deleteHospitalApi,
	deleteHospitalReset,
} from '../../actions/deleteHospitalAction';
import Header from '../../components/Header/Header';
import { XUpload } from '../Profile/ProfileStyle';
import { getRegionsApi, getRegionsReset } from '../../actions/getRegionsAction';
import {
	XButtonBack,
	XCardBackBg,
	XEditTitle,
} from '../CaseForm/CaseFormStyle';
import {
	XTheme2Button,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import { XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';

const HospitalForm = (props) => {
	const {
		getHospitalById,
		getHospitalByIdReset,
		getHospitalByIdState,
		editHospital,
		editHospitalReset,
		editHospitalState,
		addHospital,
		addHospitalReset,
		addHospitalState,
		getStateDropdownState,
		getStateDropdown,
		getRegions,
		getRegionsState,
		getOrganizations,
		getOrganizationsState,
		deleteHospitalState,
		deleteHospital,
		deleteHospitalReset,
	} = props;
	const navigate = useNavigate();
	const id = useParams().id;
	let modulePermissions = checkModulePermissions('hospital-management');

	const [form] = XThemeForm.useForm();
	const [formData, setFormData] = useState({});
	const [uploadedFile, setUploadedFile] = useState([]);
	const headerEditorRef = useRef(null);
	const footerEditorRef = useRef(null);
	const [fileToUpload, setFileToUpload] = useState(null);
	const [triggerUpdate, setTriggerUpdate] = useState(false);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [preview, setPreview] = useState('');
	console.log('fileToUpload---------------', fileToUpload);
	const [fileList, setFileList] = useState([]);

	const [displayOrganization, setDisplayOrganization] = useState(true);
	const [displayRegion, setDisplayRegion] = useState(true);
	const defaultProfilePic = [
		{
			name: 'Test',
			url: '/images/default-pic.svg',
			status: 'done',
		},
	];

	const getDocumentObject = async (document_path) => {
		if (document_path) {
			let url = `${config.s3_url}${document_path}`;
			let file_name = getFileNameFromDocPath(document_path);
			setUploadedFile([
				{
					name: file_name,
					url: url,
					status: 'done',
				},
			]);
			setFileList([
				{
					name: file_name,
					url: url,
					status: 'done',
				},
			]);
		}
		// setDataLoaded(true);
	};
	console.log('formData-----', formData);

	const uploadFile = async (currentId) => {
		if (!fileToUpload) {
			setFormData({
				...formData,
			});
			setTriggerUpdate(true);
		} else {
			const { file, onError, onSuccess, onProgress } = fileToUpload;
			let fil_name = file.name.split('.')[0];
			let get_ext = file.name.split('.');
			let ext = get_ext[get_ext.length - 1];
			let unique_id = file.uid;

			try {
				const res = await axios.get(
					`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=hospitals&file_name=${fil_name}&ext=${ext}&id=${unique_id}`,
					{
						headers: {
							'Content-type': 'application/json; charset=UTF-8',
							Authorization: 'Bearer ' + getUserToken(),
						},
					},
				);
				const result = await axios.put(res.data.data, file, {
					onUploadProgress: ({ total, loaded }) => {
						onProgress(
							{
								percent: Math.round(
									(loaded / total) * 100,
								).toFixed(0),
							},
							file,
						);
					},
				});

				if (result.status === 200) {
					let documentPath = `/hospitals/${unique_id}/${fil_name}.${ext}`;
					setFormData({
						...formData,
						logo: documentPath,
					});

					onSuccess(result, file);
				}
			} catch (error) {
				console.log('Try and catch error => ', error.message);
				notification.error({
					message: `Unable to upload file`,
				});
				return error;
			}
			setTriggerUpdate(true);
		}
	};
	const handleOnFinish = () => {
		form.validateFields().then(() => {
			uploadFile(formData._id);
		});
	};
	// use effects
	useEffect(() => {
		if (id) {
			setDataLoaded(true);
			getHospitalById({ id: id });
		}
		localStorage.getItem('role') === 'organization-admin' && getRegions();
		getStateDropdown();
		getOrganizations();
	}, [id]);

	useEffect(() => {
		if (getHospitalByIdState.apiState === 'success') {
			setFormData({
				...getHospitalByIdState.data,
				id: getHospitalByIdState.data._id,
			});
			form.setFieldsValue({
				...getHospitalByIdState.data,
				id: getHospitalByIdState.data._id,
			});

			getDocumentObject(getHospitalByIdState.data.logo);
			getRegions({
				organization_id: getHospitalByIdState.data.organization,
			});
			setDataLoaded(false);
			getHospitalByIdReset();
		}
	}, [getHospitalByIdState]);

	useEffect(() => {
		if (addHospitalState.apiState === 'success') {
			setSubmitLoading(false);
			addHospitalReset();
			navigate(-1);
		}
	}, [addHospitalState]);

	useEffect(() => {
		if (editHospitalState.apiState === 'success') {
			setSubmitLoading(false);
			editHospitalReset();
			navigate(-1);
		}
	}, [editHospitalState]);

	useEffect(() => {
		if (deleteHospitalState.apiState === 'success') {
			setSubmitLoading(false);
			notification.success({ message: deleteHospitalState.message });
			deleteHospitalReset();
			navigate(-1);
		}
	}, [deleteHospitalState]);

	useEffect(() => {
		if (triggerUpdate) {
			if (id)
				editHospital({
					id: id,
					...formData,
					header: headerEditorRef.current.getContent(),
					footer: footerEditorRef.current.getContent(),
				});
			else
				addHospital({
					...formData,
					header: headerEditorRef.current.getContent(),
					footer: footerEditorRef.current.getContent(),
				});
		}
	}, [triggerUpdate]);

	useEffect(() => {
		if (localStorage.getItem('role') === 'organization-admin') {
			setDisplayOrganization(false);
			getRegions();
		}
		if (localStorage.getItem('role') === 'region-admin') {
			setDisplayOrganization(false);
			setDisplayRegion(false);
		}
		getStateDropdown();
	}, []);


	const showDeleteConfirm = (_id, name) => {
		XModal.confirm({
			title: 'Delete Hospital?',
			content: (
				<p className="modalPara1">
					Are you sure you want to delete {name}?
				</p>
			),
			icon: <img className="me-3" src="/images/delete-icon.svg" alt="" />,
			okText: 'Yes, Confirm',
			okType: 'danger',
			cancelText: 'No, Cancel',
			className: 'confirmModal',
			okButtonProps: {
				style: {
					backgroundColor: '#007299',
					borderColor: '#007299',
					color: '#fff',
				},
			},
			cancelButtonProps: {
				style: {
					background: '#fff',
					color: '#007299',
					borderRadius: '20px',
				},
			},
			onOk() {
				setSubmitLoading(true);
				deleteHospital({ id: _id });
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};
	const handleChange = (options) => {
		const file = options.file;
		const isPDF = file.type.startsWith('application/'); // Check if the file is a PDF
		const isImage = file.type.startsWith('image/'); // Check if the file is an image

		// Allow only image files and exclude PDFs
		if (!isImage || isPDF) {
			console.error('Only image files are allowed.');
			setFileToUpload(null);
			return;
		}

		// const url = URL.createObjectURL(file);
		// setPreview(url);

		setFileToUpload(options);
		options.onSuccess();
	};

	const validateFileBeforeUpload = (file) => {
		const isGIF = file.type === 'image/gif';
		const isVideo = file.type.startsWith('video/');
		const isAudio = file.type.startsWith('audio/');
		const isPDF = file.type.startsWith('application/');

		// const isLt10M = file.size / 1024 / 1024 < 10;

		if (isGIF || isVideo || isAudio || isPDF) {
			notification.error({
				message: 'File Type Error',
				description: `GIF, video, pdf and audio files are not allowed.`,
			});
			return false; // Prevent upload
		}

		return !isGIF && !isVideo && !isAudio && !isPDF;
	};

	const handleFileChange = ({ file }) => {
		// const isLt10M = file.size / 1024 / 1024 < 10;
		if (file.status === 'removed') {
			setFileList([]); // Clear the file list when a file is removed
			setFileToUpload(null);
			return;
		}

		const isPDF = file.type === 'application/pdf';
		const isImage = file.type.startsWith('image/');

		if (isImage && !isPDF) {
			setFileList([file]); // Only keep the latest valid file
		} else {
			setFileList([]);
		}
	};

	const handleRemove = () => {};
	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Hospital Management" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="hospital" />
					</Col>
				</>
			)}

			{/* {dataLoaded && ( */}
			<Spin spinning={dataLoaded}>
				{!dataLoaded ? (
					<XThemeContainer fluid>
						<XCardBackBg className="mb-3 d-lg-none">
							<Row>
								<Col xs={24}>
									<XButtonBack
										onClick={() => navigate(-1)}
										icon={<ArrowLeftOutlined />}
										size="large"
									/>
									{id ? (
										<XEditTitle>Edit Hospital</XEditTitle>
									) : (
										<XEditTitle>Add Hospital</XEditTitle>
									)}
								</Col>
							</Row>
						</XCardBackBg>
						{/* <XCardBackBg className="mb-3">
							<Row>
								<Col xs={24}>
									<XButtonBack
										onClick={() => navigate(-1)}
										icon={<ArrowLeftOutlined />}
										size="large"
									/>
									{id ? (
										<XEditTitle>Edit Hospital</XEditTitle>
									) : (
										<XEditTitle>Add Hospital</XEditTitle>
									)}{' '}
								</Col>
							</Row>
						</XCardBackBg> */}
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									{id ? 'Edit Hospital' : 'Add Hospital'}{' '}
								</XTheme2MainTitle>
							</Col>
						</Row>

						<XThemeDetailsCards className="noBGMobile largePadding mb-3">
							{modulePermissions.sub_modules.includes(
								'add-hospitals',
								'update-hospitals',
							) ? (
								<>
									<XThemeForm
										form={form}
										name="roleForm"
										layout="vertical"
										autoComplete="off"
										onFinish={() => {
											setSubmitLoading(true);
											handleOnFinish();
										}}
									>
										<Row gutter={(15, 15)}>
											<Col xs={24} sm={24} md={8} lg={8}>
												<XThemeForm.Item
													name="logo"
													// label="Upload Logo"
													rules={[
														{
															required: true,
															validator: (
																_,
																value,
															) => {
																if (
																	fileList.length ===
																	0
																) {
																	return Promise.reject(
																		new Error(
																			'Please add logo!',
																		),
																	);
																}
																return Promise.resolve();
															},
														},
													]}
												>
													<div className="borderRightOnly">
														<XThemeUploadProfile
															listType="picture-circle"
															maxCount={1}
															accept="image/png, image/jpeg, image/jpg"
															defaultFileList={
																id
																	? uploadedFile
																	: []
															}
															fileList={
																fileList.length >
																0
																	? fileList
																	: defaultProfilePic
															}
															showUploadList={{
																showPreviewIcon: false,
																showRemoveIcon: true,
															}}
															beforeUpload={(
																file,
															) => {
																validateFileBeforeUpload(
																	file,
																);
																return true;
															}}
															onChange={
																handleFileChange
															}
															customRequest={(
																options,
															) => {
																handleChange(
																	options,
																);
															}}
														>
															Upload Logo
														</XThemeUploadProfile>
													</div>
												</XThemeForm.Item>
											</Col>
											<Col
												xs={24}
												sm={24}
												md={16}
												lg={16}
											>
												<Row gutter={(15, 15)}>
													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="name"
															label="Name"
															rules={[
																{
																	required: true,
																	message:
																		'Please enter Hospital name',
																},
															]}
														>
															<XThemeInputText
																className="largeInputForms"
																prefix={
																	<img
																		src="/images/input-user-icon.svg"
																		alt=""
																	/>
																}
																size="large"
																placeholder="Enter Hospital Name"
																name="name"
																onChange={(e) =>
																	handleInputChange(
																		e,
																		formData,
																		setFormData,
																	)
																}
															/>
														</XThemeForm.Item>
													</Col>
													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="contact_person_email_address"
															label="Contact Person Email Address"
															rules={[
																{
																	type: 'email',
																	message:
																		'Please enter a valid email address',
																},
															]}
														>
															<XThemeInputText
																className="largeInputForms"
																prefix={
																	<img
																		src="/images/input-email-icon.svg"
																		alt=""
																	/>
																}
																size="large"
																placeholder="Enter Contact Person Email Address"
																name="contact_person_email_address"
																onInput={
																	lowerCaseInput
																}
																onChange={(e) =>
																	handleInputChange(
																		e,
																		formData,
																		setFormData,
																	)
																}
															/>
														</XThemeForm.Item>
													</Col>
													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="contact_person_mobile_number"
															label="Contact Person Mobile Number"
															rules={[
																{
																	validator:
																		validateMobileNumber,
																},
															]}
														>
															<XThemeInputText
																className="largeInputForms"
																prefix={
																	<img
																		src="/images/input-mobile-icon.svg"
																		alt=""
																	/>
																}
																size="large"
																placeholder="Enter Contact Person Mobile Number"
																name="contact_person_mobile_number"
																onChange={(e) =>
																	handleInputChange(
																		e,
																		formData,
																		setFormData,
																	)
																}
															/>
														</XThemeForm.Item>
													</Col>
													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="fax_number"
															label="Fax Number"
														>
															<XThemeInputText
																className="largeInputForms"
																prefix={
																	<img
																		src="/images/input-fax-icon.svg"
																		alt=""
																	/>
																}
																size="large"
																placeholder="Enter Fax Number"
																name="fax_number"
																onChange={(e) =>
																	handleInputChange(
																		e,
																		formData,
																		setFormData,
																	)
																}
															/>
														</XThemeForm.Item>
													</Col>
													<Col xs={24}>
														<XThemeForm.Item
															className="drawerlabel"
															name="address"
															label="Address"
														>
															<XThemeInputText
																className="largeInputForms"
																prefix={
																	<img
																		src="/images/input-location-icon.svg"
																		alt=""
																	/>
																}
																size="large"
																placeholder="Enter Address"
																name="address"
																onChange={(e) =>
																	handleInputChange(
																		e,
																		formData,
																		setFormData,
																	)
																}
															/>
														</XThemeForm.Item>
													</Col>
													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="state"
															label={'State'}
														>
															<XThemeSelect
																className="largeInputForms"
																size="large"
																placeholder="Select State"
																name="state"
																showSearch={
																	true
																}
																filterOption={
																	filterByLabel
																}
																options={
																	getStateDropdownState.apiState ===
																		'success' &&
																	getStateDropdownState
																		.data
																		.all_states
																		?.length >
																		0 &&
																	getStateDropdownState.data.all_states.map(
																		(
																			itm,
																		) => {
																			return {
																				label: itm.state,
																				value: itm.state,
																				providers:
																					itm.providers,
																			};
																		},
																	)
																}
																onSelect={(
																	value,
																	options,
																) => {
																	handleSelectChange(
																		'state',
																		value,
																		formData,
																		setFormData,
																	);
																}}
															/>
														</XThemeForm.Item>
													</Col>
													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="city"
															label="City"
														>
															<XThemeInputText
																className="largeInputForms"
																prefix={
																	<img
																		src="/images/input-location-icon.svg"
																		alt=""
																	/>
																}
																size="large"
																placeholder="Enter City"
																name="city"
																onChange={(e) =>
																	handleInputChange(
																		e,
																		formData,
																		setFormData,
																	)
																}
															/>
														</XThemeForm.Item>
													</Col>
													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="pincode"
															label="Pincode"
														>
															<XThemeInputText
																className="largeInputForms"
																prefix={
																	<img
																		src="/images/input-location-icon.svg"
																		alt=""
																	/>
																}
																size="large"
																placeholder="Enter Pincode"
																name="pincode"
																onChange={(e) =>
																	handleInputChange(
																		e,
																		formData,
																		setFormData,
																	)
																}
															/>
														</XThemeForm.Item>
													</Col>
													{displayOrganization ? (
														<Col
															xs={24}
															sm={24}
															md={12}
															lg={12}
														>
															<XThemeForm.Item
																className="drawerlabel"
																name="organization"
																label={
																	'Organization'
																}
																rules={[
																	{
																		required: true,
																		message:
																			'Please enter Region name',
																	},
																]}
															>
																<XThemeSelect
																	className="largeInputForms"
																	size="large"
																	placeholder="Select Organization"
																	name="organization"
																	showSearch={
																		true
																	}
																	onSearch={(
																		search,
																	) => {
																		if (
																			search.length >=
																			3
																		) {
																			getOrganizations(
																				{
																					search,
																				},
																			);
																		} else if (
																			search.length ===
																			0
																		) {
																			getOrganizations();
																		}
																	}}
																	filterOption={
																		filterByLabel
																	}
																	options={
																		getOrganizationsState.apiState ===
																			'success' &&
																		getOrganizationsState
																			.data
																			.list
																			?.length >
																			0 &&
																		getOrganizationsState.data.list.map(
																			(
																				itm,
																			) => {
																				return {
																					label: itm.name,
																					value: itm._id,
																				};
																			},
																		)
																	}
																	onSelect={(
																		value,
																		options,
																	) => {
																		handleSelectChange(
																			'organization',
																			value,
																			formData,
																			setFormData,
																		);
																		getRegions(
																			{
																				organization_id:
																					value,
																			},
																		);
																		form.setFieldValue(
																			'region',
																			null,
																		);
																	}}
																/>
															</XThemeForm.Item>
														</Col>
													) : (
														<></>
													)}
													{displayRegion ? (
														<Col
															xs={24}
															sm={24}
															md={12}
															lg={12}
														>
															<XThemeForm.Item
																className="drawerlabel"
																name="region"
																label={'Region'}
																rules={[
																	{
																		required: true,
																		message:
																			'Please enter Region name',
																	},
																]}
															>
																<XThemeSelect
																	className="largeInputForms"
																	size="large"
																	placeholder="Select Region"
																	name="region"
																	filterOption={
																		filterByLabel
																	}
																	options={
																		getRegionsState.apiState ===
																			'success' &&
																		getRegionsState
																			.data
																			.regions
																			?.length >
																			0 &&
																		getRegionsState.data.regions.map(
																			(
																				itm,
																			) => {
																				return {
																					label: itm.name,
																					value: itm._id,
																				};
																			},
																		)
																	}
																	onSelect={(
																		value,
																		options,
																	) => {
																		handleSelectChange(
																			'region',
																			value,
																			formData,
																			setFormData,
																		);
																	}}
																/>
															</XThemeForm.Item>
														</Col>
													) : (
														<></>
													)}

													<Col
														xs={24}
														sm={24}
														md={12}
														lg={12}
													>
														<XThemeForm.Item
															className="drawerlabel"
															name="visit_types"
															label="Visit Options"
															rules={[
																{
																	required: true,
																	message:
																		'Please add visit options',
																},
															]}
														>
															<XThemeSelect
																className="largeInputForms"
																size="large"
																mode="tags"
																placeholder="Please add visit options"
																onChange={(
																	value,
																) => {
																	handleSelectChange(
																		'visit_types',
																		value,
																		formData,
																		setFormData,
																	);
																}}
																onInput={
																	upperCaseInput
																}
															/>
														</XThemeForm.Item>
													</Col>
													
													<Col xs={24}>
														<XThemeForm.Item
															className="drawerlabel"
															label="Header"
															name="header"
															rules={[
																{
																	required: true,
																	message:
																		'Please enter Header',
																},
															]}
														>
															<Editor
																apiKey={
																	config.tiny_url_key
																}
																initialValue={
																	formData.header
																}
																onInit={(
																	evt,
																	editor,
																) =>
																	(headerEditorRef.current =
																		editor)
																}
																init={{
																	menubar: false,
																	height: 200,
																	width: '100%',
																	plugins: [
																		'code',
																		'image',
																		'link',
																		'visualblocks',
																	],
																	branding: false,
																	toolbar:
																		'undo redo | formatselect | ' +
																		'bold italic backcolor | alignleft aligncenter alignright alignjustify | blocks fontfamily fontsize | ' +
																		'bullist numlist outdent indent | image link |' +
																		'removeformat | visualblocks code | help ',
																	content_style:
																		'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
																	font_size_formats:
																		'8px 10px 12px 14px 18px 24px 36px',
																}}
															/>
														</XThemeForm.Item>
													</Col>
													<Col xs={24}>
														<XThemeForm.Item
															className="drawerlabel"
															label="Footer"
															name="footer"
															rules={[
																{
																	required: true,
																	message:
																		'Please enter Footer',
																},
															]}
														>
															<Editor
																apiKey={
																	config.tiny_url_key
																}
																onInit={(
																	evt,
																	editor,
																) =>
																	(footerEditorRef.current =
																		editor)
																}
																initialValue={
																	formData.footer
																}
																init={{
																	menubar: false,
																	height: 200,
																	width: '100%',
																	plugins: [
																		'code',
																		'image',
																		'link',
																		'visualblocks',
																	],
																	branding: false,
																	toolbar:
																		'undo redo | formatselect | ' +
																		'bold italic backcolor | alignleft aligncenter alignright alignjustify | blocks fontfamily fontsize | ' +
																		'bullist numlist outdent indent | image link |' +
																		'removeformat | visualblocks code | help ',
																	content_style:
																		'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
																	font_size_formats:
																		'8px 10px 12px 14px 18px 24px 36px',
																}}
															/>
														</XThemeForm.Item>
													</Col>
												</Row>
												<Row gutter={(15, 15)}>
													<Col
														xs={24}
														sm={12}
														md={8}
														lg={8}
														className="text-center mb-2 mb-sm-0 text-sm-start"
													>
														{id ? (
															<Space>
																<XTheme2Button
																	className="submitCancel px-4"
																	shape="round"
																	loading={
																		submitLoading
																	}
																	onClick={() =>
																		showDeleteConfirm(
																			id,
																		)
																	}
																>
																	Delete
																	Hospital
																</XTheme2Button>
															</Space>
														) : (
															<></>
														)}
													</Col>
													<Col
														xs={24}
														sm={12}
														md={16}
														lg={16}
														className="text-center text-sm-end"
													>
														<Space>
															<XTheme2Button
																className="noBackground borderColor submitCancel px-4"
																shape="round"
																onClick={() => {
																	form.resetFields();
																	navigate(
																		'/hospital',
																	);
																	setFormData(
																		{},
																	);
																}}
															>
																Cancel
															</XTheme2Button>
															<XTheme2Button
																className="submitCancel px-4"
																shape="round"
																loading={
																	submitLoading
																}
																htmlType="submit"
															>
																Submit
															</XTheme2Button>
														</Space>
													</Col>
												</Row>
											</Col>
										</Row>
									</XThemeForm>
								</>
							) : (
								<Result
									status="403"
									title="403"
									subTitle="Sorry, you are not authorized to access this page."
									extra={
										<Button
											type="primary"
											onClick={() => navigate('/')}
										>
											Back Home
										</Button>
									}
								/>
							)}
						</XThemeDetailsCards>
					</XThemeContainer>
				) : (
					<div
						style={{
							display: 'flex', // Enable Flexbox
							justifyContent: 'center', // Center horizontally
							alignItems: 'center', // Center vertically
							height: '100vh', // Full height of the viewport
						}}
					></div>
				)}
			</Spin>
			{/* )} */}
		</>
	);
};

const mapStateToProps = (state) => ({
	getHospitalByIdState: state.getHospitalById,
	editHospitalState: state.editHospital,
	addHospitalState: state.addHospital,
	getStateDropdownState: state.getStateDropdown,
	getRegionsState: state.getRegions,
	getOrganizationsState: state.getOrganizations,
	deleteHospitalByIdState: state.deleteHospitalById,
	deleteHospitalState: state.deleteHospital,
});

const mapDispatchToProps = (dispatch) => ({
	getHospitalById: (data) => dispatch(getHospitalByIdApi(data)),
	getHospitalByIdReset: () => dispatch(getHospitalByIdReset()),
	editHospital: (data) => dispatch(editHospitalApi(data)),
	editHospitalReset: () => dispatch(editHospitalReset()),
	addHospital: (data) => dispatch(addHospitalApi(data)),
	addHospitalReset: () => dispatch(addHospitalReset()),
	getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
	getRegions: (params) => dispatch(getRegionsApi(params)),
	getOrganizations: (data) => dispatch(getOrganizationsApi(data)),
	getOrganizationsReset: () => dispatch(getOrganizationsReset()),
	getRegionsReset: () => dispatch(getRegionsReset()),
	deleteHospital: (data) => dispatch(deleteHospitalApi(data)),
	deleteHospitalReset: () => dispatch(deleteHospitalReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HospitalForm);
